import { API } from 'aws-amplify';

export function getCities() {
  return API.get('party', '/cities', {});
}
